import { ObjectIdString } from "@r6digital/rapidstor-types";
import Location from "./Location";
import UnitType, { unitTypeTransformer } from "./UnitType";
import { PostProcessedDescriptor } from "@r6digital/rapidstor-types/types/Descriptor";

export default interface Descriptor {
  _id: string;
  locationCode: string;
  corpCode: string;
  name: string;
  description: string;
  descriptions: string[];
  picture: string;
  slides: string[];
  defaultInsuranceCoverage?: null | ObjectIdString;
  deals: string[];
  enabled: boolean;
  hidden: boolean;
  unitTypes: UnitType[];
  ordinalPosition: number;
  area: number | string;
}

export interface UnitList {
  unitTypes: UnitType[];
  descriptors: Descriptor[];
}

const descriptorMinArea = (descriptor: PostProcessedDescriptor): number => {
  const sizeCriteria = descriptor.criteria?.includes?.sizes ?? [];
  return Math.min(
    ...descriptor.unitTypes.map((u) => u.dcArea),
    ...sizeCriteria.map((s) => s.width * s.length)
  );
};

export const descriptorTransformer = (
  descriptor: PostProcessedDescriptor,
  location?: Location
): Descriptor => {
  return {
    _id: descriptor._id,
    locationCode: descriptor.sLocationCode,
    corpCode: descriptor.sCorpCode,
    name: descriptor.name,
    description: descriptor.description,
    descriptions: descriptor.descriptions,
    picture: descriptor.picture,
    slides: descriptor.slides,
    defaultInsuranceCoverage: descriptor.defaultInsuranceCoverage,
    deals: descriptor.deals,
    enabled: descriptor.enabled,
    hidden: descriptor.hidden,
    unitTypes: descriptor.unitTypes.map((u) => unitTypeTransformer(u, location)),
    ordinalPosition: descriptor.ordinalPosition,
    area: descriptorMinArea(descriptor),
  };
};
